<template>
    <div class="animated fadeIn">
        <b-card>
            <form @submit.prevent="validate">
                <div class="form-row justify-content-start">
                    <div class="col-sm-12 col-md-6 col-lg-3 col-xl-2">
                        <div class="form-group selectpicker" data-live-search="true">
                            <label>Evento</label>
                            <v-wait for="loading-event">
                                <template slot="waiting">
                                <input disabled type="text" value="Aguarde..." class="form-control" />
                                </template>
                                <select :class="{'custom-select': true}" v-model="request.eventId">
                                <option
                                    v-for="(s, index) in events"
                                    :key="index"
                                    :value="s.id"
                                >{{s.name}}</option>
                                </select>
                            </v-wait> 
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                        <div class="form-group">
                            <label>Terminais POS</label>
                            <model-list-select
                                :list="devices.data"
                                option-value="serialNumber"
                                option-text="serialNumber"
                                v-model="request.machineSerial"
                                placeholder="Digite o serial do terminal"
                                @searchchange="searchDevices"
                            ></model-list-select>              
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 col-xl-2">
                        <div class="form-group">
                            <label>Status</label>
                            <select class="custom-select" v-model="request.operationStatus">
                                <option value="">Todos</option>
                                <option value="PAID">Pago</option>
                                <!-- <option value="APPROVED">Aprovado</option> -->
                                <option value="CANCELLED">Cancelado</option>
                                <!-- <option value="PENDING">Pendente</option> -->
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 col-xl-2">
                        <div class="form-group">
                            <label>Caixa</label>
                            <input type="text" class="form-control" v-model="request.cashierName" placeholder="Nome do caixa" />
                        </div>
                    </div>
                </div>
                <div class="row justify-content-start">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Início</label>
                            <datepicker
                                :language="languages.ptBR"
                                :bootstrapStyling="true"
                                placeholder="Início"
                                :calendar-button="true"
                                calendar-button-icon="fa fa-calendar"
                                v-model="request.startDate"
                            ></datepicker>
                        </div>
                    </div>                    
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Término</label>
                            <datepicker
                                :language="languages.ptBR"
                                :bootstrapStyling="true"
                                placeholder="Termino"
                                :calendar-button="true"
                                calendar-button-icon="fa fa-calendar"
                                v-model="request.endDate"
                            ></datepicker>
                        </div>
                    </div>                    
                </div>
                <input type="submit" class="btn btn-primary" value="Buscar" />
            </form>
        </b-card>
        <b-card>
            <b-table
                :items="result.data"
                :fields="fields"
                :striped="true"
                :busy="trxLoading"
                responsive
            >
                <template #table-busy>
                    <div class="text-center text-danger">
                        <strong>Aguarde...</strong>
                    </div>
                </template>                
                <template #cell(vid)="data"><small>{{data.value}}</small></template>
                <template #cell(localDate)="data">{{formatDateTime(data.value)}}</template>
                <template #cell(total)="data">{{formatDecimal(data.value)}}</template>
                <template #cell(status)="data">{{getStatusName(data.value)}}</template>
                <template #cell(actions)="data">
                    <b-button size="sm" variant="primary" @click="viewDetail(data.item)">
                        <i class="fa fa-eye"></i> 
                    </b-button>
                </template>
            </b-table>
             <nav>
                <b-pagination
                    :total-rows="result.rowCount"
                    :per-page.sync="result.pageSize"
                    v-model="currentPage"
                    prev-text="Voltar"
                    next-text="Próximo"
                    @change="onPageIndexChanged"
                    first-text="Primeiro"
                    last-text="Último"
                />
            </nav>
        </b-card>

        <!-- Modal de Detalhe do Pedido -->
        <b-modal
            v-model="showDetailModal"
            size="xl"
            title="Detalhe do Pedido"
            hide-footer
            centered
        >
            <div v-if="detailLoading" class="text-center text-danger my-4">
                <strong>Aguarde...</strong>
            </div>
            <div v-if="!detailLoading && detailOrder">
                <div class="row mb-3">
                    <div class="col-md-8">
                        <table class="table table-sm table-borderless mb-0">
                            <tbody>
                                <tr>
                                    <td class="text-muted" style="width:140px"><strong>Evento</strong></td>
                                    <td>{{detailOrder.eventName}}</td>
                                    <td class="text-muted" style="width:140px"><strong>Terminal</strong></td>
                                    <td>{{detailOrder.machineSerial}}</td>
                                </tr>
                                <tr>
                                    <td class="text-muted"><strong>Data</strong></td>
                                    <td>{{formatDateTime(detailOrder.localDate)}}</td>
                                    <td class="text-muted"><strong>Caixa</strong></td>
                                    <td>{{detailOrder.cashierName}}</td>
                                </tr>
                                <tr>
                                    <td class="text-muted"><strong>Status</strong></td>
                                    <td><b-badge :variant="detailOrder.status === 'CANCELLED' ? 'danger' : 'success'">{{detailOrder.statusText || detailOrder.status}}</b-badge></td>
                                    <td class="text-muted"><strong>Qtde. Itens</strong></td>
                                    <td>{{detailOrder.itemCount}}</td>
                                </tr>
                                <tr v-if="parsedMetadata">
                                    <td class="text-muted" v-if="parsedMetadata.tab != null"><strong>Mesa</strong></td>
                                    <td v-if="parsedMetadata.tab != null">{{parsedMetadata.tab}}</td>
                                    <td class="text-muted" v-if="parsedMetadata.obs != null && parsedMetadata.obs !== ''"><strong>Observação</strong></td>
                                    <td v-if="parsedMetadata.obs != null && parsedMetadata.obs !== ''">{{parsedMetadata.obs}}</td>
                                </tr>
                                <tr v-if="parsedMetadata && (hasMetaField('customerName') || hasMetaField('customerPhone'))">
                                    <td class="text-muted" v-if="hasMetaField('customerName')"><strong>Cliente</strong></td>
                                    <td v-if="hasMetaField('customerName')">{{parsedMetadata.customerName}}</td>
                                    <td class="text-muted" v-if="hasMetaField('customerPhone')"><strong>Telefone</strong></td>
                                    <td v-if="hasMetaField('customerPhone')">{{parsedMetadata.customerPhone}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-4 text-center d-flex flex-column align-items-center justify-content-center">
                        <small class="text-muted text-uppercase">Total do Pedido</small>
                        <h2 class="text-success font-weight-bold mb-1">{{formatDecimal(detailOrder.total)}}</h2>
                        <small class="text-muted">{{detailOrder.paymentCount}} pagamento(s)</small>
                    </div>
                </div>

                <hr />
                <h6 class="text-muted text-uppercase mb-3" v-if="detailPayments && detailPayments.length > 0">
                    <i class="fa fa-credit-card"></i> Pagamentos
                </h6>
                <b-table
                    v-if="detailPayments && detailPayments.length > 0"
                    :items="detailPayments"
                    :fields="paymentFields"
                    :striped="true"
                    responsive
                    small
                >
                    <template #cell(amount)="data">{{formatDecimal(data.value)}}</template>
                </b-table>

                <hr v-if="detailItems && detailItems.length > 0" />
                <h6 class="text-muted text-uppercase mb-3" v-if="detailItems && detailItems.length > 0">
                    <i class="fa fa-list"></i> Itens
                </h6>
                <b-table
                    v-if="detailItems && detailItems.length > 0"
                    :items="detailItems"
                    :fields="itemFields"
                    :striped="true"
                    responsive
                    small
                >
                    <template #table-busy>
                        <div class="text-center text-danger">
                            <strong>Aguarde...</strong>
                        </div>
                    </template>                    
                    <template #cell(price)="data">{{formatDecimal(data.value)}}</template>
                    <template #cell(subtotal)="data">{{formatDecimal(data.value)}}</template>
                </b-table>
            </div>
        </b-modal>
    </div>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelListSelect } from "vue-search-select";
import Datepicker from "vuejs-datepicker";
import reportPage from '../reportPage';

import barOrderService from '../../../services/BarOrders/BarOrderService';
import devicesService from '../../../services/Devices/DevicesService';
import eventService from '../../../services/Events/EventService';
export default {
    name: "report-bar-orders-list",
    inheritAttrs: false,
    mixins: [reportPage],
    components: {
        ModelListSelect,
        Datepicker
    },
    data() {
        return {
            request: {
                startDate: new Date(),
                endDate: new Date(),
                eventId: null,
                machineSerial: '',
                operationStatus: '',
                cashierName: '',
            },
            trxLoading: false,
            devices: {
                data: [],
                query: '',
            },
            events: [],
            fields:[                
                { key: "vid", label: "ID", sortable: false },
                { key: "eventName", label: "Evento", sortable: false },
                { key: "localDate", label: "Data", sortable: false },
                { key: "machineSerial", label: "Terminal", sortable: false },
                { key: "cashierName", label: "Caixa", sortable: false },
                { key: "itemCount", label: "Qtde. Itens", sortable: false },
                { key: "paymentCount", label: "Qtde. Pagtos", sortable: false },
                { key: "status", label: "Status", sortable: false },
                { key: "total", label: "Total", sortable: false },
                { key: "actions", label: "" }               
            ],
            // Modal detail state
            showDetailModal: false,
            detailLoading: false,
            detailOrder: null,
            detailPayments: [],
            detailItems: [],
            paymentFields: [
                { key: "paymentMethod", label: "Forma Pagto.", sortable: false },
                { key: "name", label: "Bandeira", sortable: false },
                { key: "amount", label: "Valor", sortable: false },
                { key: "installments", label: "Parcelas", sortable: false },
                { key: "transactionCode", label: "Cod. Transação", sortable: false },
            ],
            itemFields: [
                { key: "name", label: "Nome", sortable: false },
                { key: "family", label: "Família", sortable: false },
                { key: "price", label: "Preço", sortable: false },
                { key: "quantity", label: "Quantidade", sortable: false },
                { key: "subtotal", label: "Subtotal", sortable: false },
            ],
        }
    },
    filters: {
        stringify(value) {
            return JSON.stringify(value, null, 2);
        }
    },
    computed: {
        parsedMetadata() {
            if (!this.detailOrder || !this.detailOrder.metadata) return null;
            try {
                const meta = JSON.parse(this.detailOrder.metadata);
                if (!meta || typeof meta !== 'object') return null;
                // Only return if there's at least one meaningful value
                const hasTab = meta.tab != null;
                const hasObs = meta.obs != null && meta.obs !== '';
                const hasCustomerName = meta.customerName != null && meta.customerName !== '';
                const hasCustomerPhone = meta.customerPhone != null && meta.customerPhone !== '';
                return (hasTab || hasObs || hasCustomerName || hasCustomerPhone) ? meta : null;
            } catch(e) {
                return null;
            }
        }
    },
    async created() {        
        await this.fetchEventsData();
        this.fetchData(1);
    },
    mounted() {
        
    },
    methods: {
        async fetchEventsData() {
            this.$wait.start("loading-events");      
            let response = await eventService.getAll();
            this.events = response.status == 204 ? [] : response.data;
            this.events.unshift({ id: null, name: "Todos" });
            this.$wait.end("loading-events");  
        },
        validate() {
            this.fetchData(1);
        },
        searchDevices(q) {
            if (q == null || q.length < 2) return;
            const self = this;            
            devicesService.getAll(q, this.request.eventId).then(
                (response) => {
                    self.devices.data = response.status == 204 ? [] : response.data;                    
                },
                () => {
                    self.devices.data = [];
                }
            );
        },
        fetchData(page) {
            const self = this;
            this.showLoading();
            this.trxLoading = true;
            barOrderService.searchAggregated(this.request, page)
            .then(
                (response) => {
                    self.$data.result =
                        response.status == 204 ? self.getEmptyResult() : response.data;                                                 
                    self.hideLoading();
                    self.trxLoading = false;
                },
                () => {
                    self.result = self.getEmptyResult();
                    self.hideLoading();
                    self.trxLoading = false;
                }
            );
        },
        getStatusName(data) {
            switch(data) {
                case 'PAID': return 'Pago'
                case 'APPROVED': return 'Aprovado'
                case 'CANCELLED': return 'Cancelado'
                case 'PENDING': return 'Pendente'
                case 'ACTIVE': return 'Ativo'
                default: return data || ''
            }
        },
        hasMetaField(field) {
            return this.parsedMetadata && this.parsedMetadata[field] != null && this.parsedMetadata[field] !== '';
        },
        viewDetail(item) {
            const self = this;
            self.detailOrder = null;
            self.detailPayments = [];
            self.detailItems = [];
            self.detailLoading = true;
            self.showDetailModal = true;
            barOrderService.getDetail(item.vid)
            .then(
                (response) => {
                    if (response.status == 200 && response.data) {
                        self.detailOrder = response.data.order;
                        self.detailPayments = response.data.payments || [];
                        self.detailItems = response.data.items || [];
                    }
                    self.detailLoading = false;
                },
                () => {
                    self.detailLoading = false;
                }
            );
        }
    }
}
</script>
